import React from 'react'
import './portfolio.css'
import MG1 from '../../assets/portfolio1.png'
import MG2 from '../../assets/portfolio2.png'
import MG3 from '../../assets/portfolio3.png'
import MG4 from '../../assets/portfolio4.png'
import MG5 from '../../assets/portfolio5.png'
import MG6 from '../../assets/portfolio6.png'

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className='container portfolio__container'>

        <article className='portfolio__item'>
          <div className='portfolio__item_image'>
            <img src={MG1} />
          </div>
          <h3>Shopify Ecommerce App</h3>
          {/* <a href='#' className='btn' target='_blank'>Github</a>
          <a href='#' className='btn btn-primary' target='_blank'>Github</a> */}
        </article>

        <article className='portfolio__item'>
          <div className='portfolio__item_image'>
            <img src={MG2} />
          </div>
          <h3>Chat App</h3>
          {/* <a href='#' className='btn'>Github</a>
          <a href='#' className='btn btn-primary'>Github</a> */}
        </article>

        <article className='portfolio__item'>
          <div className='portfolio__item_image'>
            <img src={MG3} />
          </div>
          <h3>Ecommerce App</h3>
          {/* <a href='#' className='btn'>Github</a>
          <a href='#' className='btn btn-primary'>Github</a> */}
        </article>

        <article className='portfolio__item'>
          <div className='portfolio__item_image'>
            <img src={MG4} />
          </div>
          <h3>Expense Management App</h3>
          {/* <a href='#' className='btn'>Github</a>
          <a href='#' className='btn btn-primary'>Github</a> */}
        </article>

        <article className='portfolio__item'>
          <div className='portfolio__item_image'>
            <img src={MG5} />
          </div>
          <h3>Ecommerce App</h3>
          {/* <a href='#' className='btn'>Github</a>
          <a href='#' className='btn btn-primary'>Github</a> */}
        </article>

        <article className='portfolio__item'>
          <div className='portfolio__item_image'>
            <img src={MG6} />
          </div>
          <h3>Logistics App</h3>
          {/* <a href='#' className='btn'>Github</a>
          <a href='#' className='btn btn-primary'>Github</a> */}
        </article>

      </div>
    </section>
  )
}

export default Portfolio